import Marquee from "react-fast-marquee";

const WORDS = ["Weddings", "Club Nights", "Private Parties", "Corporate", "Festivals", "Birthdays"];

export const EditorialMarquee = () => {
  return (
    <section className="relative border-y border-white/5 bg-ink-950 py-10 md:py-14">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-oswald text-[9vw] font-700 uppercase leading-none tracking-tighter text-white md:text-[7vw]">
              {w}
            </span>
            <span className="mx-8 text-gold text-[4vw] md:mx-14 md:text-[2.5vw]">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
